var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchClientConfig } from "./features/client-config";
export const loadFeatures = (dependencies, config, pathConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const FeatureNotLoaded = () => {
        throw new Error("Trying to use an APEX feature that is not loaded - add it to module dependencies");
    };
    const features = {
        popup: {
            show: FeatureNotLoaded,
            hide: FeatureNotLoaded
        },
        widget: {
            register: FeatureNotLoaded
        },
        toast: {
            add: FeatureNotLoaded,
            close: FeatureNotLoaded
        },
        sounds: {
            load: FeatureNotLoaded,
            setMuted: FeatureNotLoaded
        },
        clientConfig: {
            get: FeatureNotLoaded
        }
    };
    const requiredFeatures = new Set();
    dependencies.dependencies.forEach((dependency) => {
        requiredFeatures.add(dependency);
    });
    if (requiredFeatures.has("popup")) {
        features.popup = (yield import("./features/popup")).default;
    }
    if (requiredFeatures.has("widget")) {
        features.widget = (yield import("./features/widget")).default;
    }
    if (requiredFeatures.has("toast")) {
        features.toast = (yield import("./features/toast")).default;
    }
    if (requiredFeatures.has("sounds")) {
        features.sounds = (yield import("./features/sounds")).default;
    }
    if (requiredFeatures.has("clientConfig")) {
        const data = yield fetchClientConfig(pathConfig);
        features.clientConfig.get = () => data;
    }
    if (requiredFeatures.has("pixi")) {
        const pixiScript = document.createElement("script");
        pixiScript.src = `${(_a = config.assetPath) !== null && _a !== void 0 ? _a : "./"}libs/pixi.min.js`;
        document.body.appendChild(pixiScript);
        yield new Promise((resolve) => {
            pixiScript.onload = () => {
                resolve();
            };
        });
    }
    return features;
});
